export function getReviewsNumber(reviewsCount?: string) {
  if (!reviewsCount) {
    return 0;
  }

  return parseInt(reviewsCount.replace(/^\D+/g, ''), 10);
}
